export var QUERY_STATE;
(function (QUERY_STATE) {
    QUERY_STATE["SUCCESS"] = "SUCCESS";
    QUERY_STATE["WAITING"] = "WAITING";
    QUERY_STATE["FAIL"] = "FAIL";
    QUERY_STATE["EMPTY"] = "EMPTY";
})(QUERY_STATE || (QUERY_STATE = {}));
export const GEOMETRY_TYPE = {
    POINT: 'Point',
    LINE_STRING: 'LineString',
    POLYGON: 'Polygon',
    CIRCLE: 'Circle',
    TEXT: 'Text',
    MULTI_POINT: 'MultiPoint',
    MULTI_LINE_STRING: 'MultiLineString',
    MULTI_POLYGON: 'MultiPolygon',
    BOX: 'Box',
};
//# sourceMappingURL=constants.js.map